import { useEffect, useState } from 'react'
import { doc, getDoc, setDoc, collection, getDocs } from 'firebase/firestore'
import { db } from '../lib/firebase'

export interface AdminConfig {
  showBlog: boolean
  showEquipo: boolean
}

const DEFAULT_CONFIG: AdminConfig = {
  showBlog: true,
  showEquipo: true
}

export function useAdminConfig() {
  const [config, setConfig] = useState<AdminConfig>(DEFAULT_CONFIG)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        // Usar colección 'ajustes' y documento 'menu'
        const ref = doc(db, 'ajustes', 'menu')
        const snap = await getDoc(ref)
        if (snap.exists()) {
          setConfig(snap.data() as AdminConfig)
          console.log('[AdminConfig] Configuración cargada:', snap.data())
        } else {
          // Si no existe, crear el documento por defecto
          await setDoc(ref, DEFAULT_CONFIG)
          setConfig(DEFAULT_CONFIG)
          console.log('[AdminConfig] Documento creado con configuración por defecto')
        }
      } catch (err) {
        console.error('[AdminConfig] Error al cargar configuración:', err)
      }
      setLoading(false)
    }
    fetchConfig()
  }, [])

  const updateConfig = async (newConfig: Partial<AdminConfig>) => {
    const ref = doc(db, 'ajustes', 'menu')
    const updated = { ...config, ...newConfig }
    try {
      await setDoc(ref, updated)
      setConfig(updated)
      console.log('[AdminConfig] Configuración actualizada:', updated)
    } catch (err) {
      console.error('[AdminConfig] Error al actualizar configuración:', err)
    }
  }

  return { config, loading, updateConfig }
}
